import { FC, useEffect, useState } from 'react';
import { type CMSData } from '@/types/cmsData';
import { formatLink } from '@/utils';

//components
import FooterDropDownButton from '../footer-drop-down-btn';

//styles
import styles from './custom-list.module.scss';

//hook
// import { ScreenWidthContext } from 'Context/screen-width-context';

interface ICustomListProps {
  linkCategory?: CMSData;
}

export const CustomList: FC<ICustomListProps> = ({
  linkCategory = {
    name: '',
    uid: '',
    link: '',
    hasChildren: false,
    child: [],
  },
}) => {
  // const { isMobile } = useContext(ScreenWidthContext);
  const isMobile = false;
  const [isDropDownOpen, setIsDropDownOpen] = useState(!isMobile);

  //resets state on screen resize
  useEffect(() => {
    setIsDropDownOpen(!isMobile);
  }, [isMobile]);

  return (
    <ul className={styles.customList}>
      <li className={styles.customListItemTitle}>
        <a
          className={styles.customListItemTitleLink}
          href={formatLink(linkCategory.link)}
          aria-label={linkCategory.name}
          title={linkCategory.name}
          data-testid="anchor-link"
        >
          {linkCategory.name}
        </a>
        {isMobile ? (
          <FooterDropDownButton isDropDownOpen={isDropDownOpen} setIsDropDownOpen={setIsDropDownOpen} />
        ) : null}
      </li>
      {isDropDownOpen && linkCategory.hasChildren
        ? linkCategory.child?.map((child: any) => (
            <li key={child.uid} className={styles.customListItem}>
              <a
                className={styles.customListItemLink}
                href={formatLink(child.link)}
                aria-label={child.name}
                title={child.name}
              >
                {child.name}
              </a>
            </li>
          ))
        : null}
    </ul>
  );
};

CustomList.defaultProps = {
  linkCategory: {
    name: '',
    link: '',
    uid: '',
    hasChildren: false,
    child: [],
  },
};
